import { Col } from "react-bootstrap";
import ElementPage from "../../Elements";

// pages/DeleteAccount.jsx
export default function DeleteAccount() {
  return (
    <>
      <div style={styles.container} className="py-2">
        <div className="jtext-justify" style={{ fontFamily: "serif" }}>
          <Col md={12} lg={12} sm={12} className="text-center">
            <h6 className="text-gray-700 fw-bold">Delete Your Account</h6>

            <p className="mb-0 text-gray-600">
              If you want to delete your account, please mail with your
              registred email id at <span className="text-primary">Khunkhaarmeldi16@gmail.com</span>
            </p>
          </Col>
        </div>
      </div>
      <ElementPage />
    </>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "0 20px",
    lineHeight: "1.7",
  },
};
